export const SkeletonCard = () => {
  return (
    <div className="animate-pulse" data-testid="skeleton-card">
      <div className="aspect-video bg-ink-surface border border-white/5" />
      <div className="pt-3 flex flex-col gap-2.5">
        <div className="h-4 w-4/5 bg-ink-surface" />
        <div className="h-3 w-2/5 bg-ink-surface" />
      </div>
    </div>
  );
};
